import Logger from '@hello10/logger';

const logger = new Logger('hello10:arcs');

export default logger;
